import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Body } from "../Certificates";
import { SectionWrapper, ContainerWrapper, ListUnstyled, HelmetTitle } from "../../Components/Utils";
import Layout from "../../Components/Layout";
import Navbar from "../BannerItems/Components/Navigation";
import Banner from "../Certificates/Components/Banner";

import BannerBig from "../../Images/min-maple.jpg";
import BannerSmall from "../../Images/max-maple.jpg";
import BayviewYardslogo from "../../Images/Network/BayviewYards.jpg";
import Canadalogo from "../../Images/Network/Canada.jpg";
import AcknowledgementMD from "./Contents/AcknowledgementMarkdown.md";
import "./index.css";



class Acknowledgement extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const name = "Acknowledgement";
    return (
      <div className="App">
        <HelmetTitle title="Acknowledgement" />
        <Layout 
          head={<Navbar />}
          body={
            <React.Fragment>
              <Banner certName={name} imgPathMin={BannerBig} imgPathMax={BannerSmall} />
              <Body name={name} markdownPath={AcknowledgementMD} logos={<SponsorsLogos />}/>
            </React.Fragment>
          }
          />
      </div>
        
    );
  }    
}

const logos = [
    {
        name: "FedDev Ontario",
        url: "https://feddevontario.gc.ca",
        logo: Canadalogo
    }, 
    {
        name: "Cour Bayview Yards",
        url: "https://bayviewyards.org",
        logo: BayviewYardslogo
    }];

function SponsorsLogos () {
  return (
    <SectionWrapper backgroundColor="white" mt="3rem" mb="3rem">
      <ContainerWrapper textAlign="center">
        <ListUnstyled className="w-100 logo__list">
        {
          logos && logos.map(logo => (
            <li key={logo.name.replace(/\s/g, '')}><a href={logo.url} target="_blank" rel="noopener noreferrer"><img src={logo.logo} alt={logo.name} title={logo.name}/></a></li>
          ))
        }
        </ListUnstyled>
      </ContainerWrapper>
      </SectionWrapper>
  )
}

export default withRouter(Acknowledgement)



// WEBPACK FOOTER //
// ./src/Pages/Misc/Acknowledgement.js